export function ColumnResizeComponent(LayoutService) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      const handleContainer = angular.element('<div class=\'rc-handle-container\' />');
      element.before(handleContainer);
      let drag = false;
      const colClass = i => `.rc-${i.toString()}`;
      const scrollbarWidth = 15;
      const colPadding = 11;
      if (!LayoutService.customFactColsWidth) LayoutService.customFactColsWidth = {};
      let tableContentWidth = 0;
      const thSelector = 'tr th:visible';
      let viewMode = null;
      let tableColumns;
      const initViewMode = function() {
        if (!viewMode) {
          return;
        }

        let tableWidth = element.width();
        if (!element.width()) {
          tableWidth = parseInt(LayoutService.printWidth, 0);
          element.width(tableWidth);
        }
        // take stock of scrollbar and borders
        tableContentWidth = tableWidth - scrollbarWidth - viewMode.columns.length * colPadding;
        element.find('.fact-table-thead').width(tableWidth - scrollbarWidth - 2);
        initColumnWidths();
      };
      const initHandlers = function() {
        tableColumns = element.find(thSelector);
        element.find('.rc-handle').remove();
        tableColumns.each(function(index) {
          if (index + 1 === tableColumns.length) {
            return;
          }
          const handle = angular.element('<div class=\'rc-handle\' />');
          handle.data('rc-id', index);
          handle.data('leftCol', this);
          handle.appendTo(handleContainer);
        });
      };
      const syncHandlers = function() {
        const height = element.height();
        handleContainer.find('.rc-handle').each(function() {
          const handler = angular.element(this);
          const column = angular.element(handler.data('leftCol'));
          const left = column.outerWidth() + (
            column && column.offset() && handleContainer && handleContainer.offset() ?
            column.offset().left - handleContainer.offset().left : 0
          );
          handler.css({
            left: left,
            height: height
          });
        });
      };
      const initColumnWidths = function() {
        if (!viewMode) return;
        // Set column width
        let tableContentWidthRest = tableContentWidth;
        const colWidthSumm = viewMode.colwidths.reduce((s, w, i) => {
          if (viewMode.columns[i].factKey in LayoutService.customFactColsWidth) {
            tableContentWidthRest -= LayoutService.customFactColsWidth[viewMode.columns[i].factKey];
            return s;
          }
          return s += w;
        }, 0.0);


        viewMode.colwidths.forEach((colwidth, i) => {
          let width;
          if (viewMode.columns[i].factKey in LayoutService.customFactColsWidth) {
            width = LayoutService.customFactColsWidth[viewMode.columns[i].factKey];
          } else width = Math.floor(colwidth * tableContentWidthRest / colWidthSumm);
          element.find(colClass(i)).width(width);
        });
      };

      scope.$on('factsLoaded', function() {
        initViewMode();
        syncHandlers();
      });
      scope.$on('splitter1Changed', function(e, d, d2, name) {
        // if (name !== 'splitter1' && name !== 'filter-form-splitter') return; // не работает в QT
        initViewMode();
        syncHandlers();
      });

      scope.$on('resizeBeforePrint', function(e, d, d2, name) {
        initViewMode();
        syncHandlers();
      });

      scope.$on('viewModeChanged', function(e, vm) {
        if (vm.colwidths == undefined) {
          vm.colwidths = vm.columns.map(function(col) {
            return 1 / vm.columns.length;
          });
        } else {
          const prevW = vm.colwidths[vm.colwidths.length - 1];
          const w = 1 - vm.colwidths.reduce(
            function(p, c, i, a) {
              return i !== a.length - 1 ? p + c : p;
            },
            0,
          );
          vm.colwidths[vm.colwidths.length - 1] = w < prevW ? prevW : w;
        }
        viewMode = vm;
        initViewMode();
        initHandlers();
        syncHandlers();
      });
      let startPosition;
      let currentGrip;
      let currentGripPosition;
      let leftColumn;
      let leftColumnWidth;
      let rightColProps = [];
      let leftGroupWidth = 0;
      const pointerdown = e => {
        startPosition = e.pageX;
        e.preventDefault();
        drag = true;

        currentGrip = angular.element(e.currentTarget);
        currentGripPosition = currentGrip.position().left;

        const id = currentGrip.data('rc-id');

        leftColumn = element.find(colClass(id));
        leftColumnWidth = leftColumn.width();

        // Calculate left block width
        leftGroupWidth = 0;
        for (let i = 0; i <= id; i++) {
          const column = element.find(colClass(i));
          leftGroupWidth += column.width();
        }
        const rightGroupWidth = tableContentWidth - leftGroupWidth;
        for (let i = id + 1; i < viewMode.colwidths.length; i++) {
          rightColProps[i] = rightGroupWidth ? viewMode.colwidths[i] / (rightGroupWidth / tableContentWidth) : 0;
        }
      };
      const pointerup = e => {
        if (!drag) {
          return;
        }
        e.preventDefault();
        drag = false;

        if (viewMode) {
          for (let i = 0; i < viewMode.colwidths.length; i++) {
            viewMode.colwidths[i] = element.find(colClass(i))
              .width() / tableContentWidth;
          }
        }
        rightColProps = [];
        syncHandlers();
      };
      const pointermove = e => {
        if (!drag) {
          return;
        }
        e.preventDefault();

        let delta = e.pageX - startPosition;

        if (leftColumnWidth + delta < 0) {
          delta = -leftColumnWidth;
        }
        if (tableContentWidth - (leftGroupWidth + delta) < 0) {
          delta = tableContentWidth - leftGroupWidth;
        }

        if (viewMode) {
          currentGrip.css({
            left: currentGripPosition + delta
          });
          const lWidth = Math.floor(leftColumnWidth + delta);
          leftColumn.width(lWidth);
          const id = currentGrip.data('rc-id');
          if (!viewMode.columns[id]) return;
          LayoutService.customFactColsWidth[viewMode.columns[id].factKey] = lWidth;
          viewMode.colwidths[id] = (leftColumnWidth + delta) / tableContentWidth;
          let rightColumnWidth;
          if (_isAllRightColumnsZero(id, rightColProps)) {
            rightColumnWidth = (tableContentWidth - (leftGroupWidth + delta));
            element.find(colClass(id + 1)).width(rightColumnWidth);
          } else {
            for (let i = id + 1; i < viewMode.colwidths.length; i++) {
              rightColumnWidth = rightColProps[i] * (tableContentWidth - (leftGroupWidth + delta));
              if (rightColumnWidth < 0) {
                rightColumnWidth = 0;
              }
              element.find(colClass(i)).width(Math.floor(rightColumnWidth));
            }
          }
        }
        scope.$broadcast('col-resize');
      };

      const _isAllRightColumnsZero = function(id, rightColProps) {
        for (let i = id + 1; i < rightColProps.length; i++) {
          if (rightColProps[i] != 0) {
            return false;
          }
        }
        return true;
      };

      const __logProportionsSum = function() {
        const reduce = viewMode.colwidths.reduce(function(
          previousValue,
          currentValue,
          currentIndex,
          array,
        ) {
          return previousValue + currentValue;
        });
        return reduce;
      };

      const __logRealColumnWidths = function() {
        let logText = '';
        for (let i = 0; i < viewMode.colwidths.length; i++) {
          const w = element.find(colClass(i)).width();
          logText += 'w[' + i + ']=' + w + '  |  ';
        }
      };

      handleContainer.on('mousedown', '.rc-handle', pointerdown);

      document.addEventListener('mouseup', pointerup);
      document.addEventListener('mousemove', pointermove);
      scope.$on('$destroy', () => {
        document.removeEventListener('mouseup', pointerup);
        document.removeEventListener('mousemove', pointermove);
      });
    },
  };
}



// WEBPACK FOOTER //
// ./src/facts/colresize.js